import React, { Component } from "react";
import { Row, Col, Container } from 'react-bootstrap'
import SideNavbar from "../components/navbars/SideNavbar";
import NavbarOne from "../components/navbars/NavbarOne";
import Footer from "../components/footer/Footer";
import * as Cookies from "es-cookie";
import { withRouter } from "react-router-dom";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import Preloader from "../components/preloader/Preloader";

import StundentDiaryHome from "../components/studentDiary/StudentDiaryHome";
import { PageCardShimmer } from "../components/preloader/PageCardShimmer";
import { getAuthorizedBranchIds } from "../utils/authHelper";


import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

const GET_STUDENT_DETAILS = gql`
query($institute_id:Int){
    getNewEducationalStudents(institute_id: $institute_id) {
        roll_no
        student_name
        class_id
        class_name
        exam_id
        exam_name
        branch_id
        branch_name
        section_id
        section_name
        parent_name
        parent_mobile
        parent_password
        student_id
      }
}
`
// Branch list source (replaces the old `globals` query). StudentDiaryHome drives its
// own Branch/Class/Section/Stream cascade from getBranches directly; this page only
// needs the branch list, restricted to the branches the user is authorized for.
const GET_BRANCHES = gql`
  query($institution_id: Int!) {
    getBranches(institution_id: $institution_id) {
      id
      branch_name
      sections {
        id
        stream_id
        section_name
        class_id
      }
    }
  }
`;



class StudentDiary extends Component {
  menuToggler = () => {
    const toggled = Cookies.get("toggle");
    if (toggled === "wrapper") {
      this.setState({ toggled: "wrapper sidebar-enable" });
      Cookies.set("toggle", "wrapper sidebar-enable");
    } else {
      this.setState({ toggled: "wrapper" });
      Cookies.set("toggle", "wrapper");
    }
  };
  render() {
    if (Cookies.get("token") == undefined) this.props.history.push("/login");
    const branchesData = this.props.branchesData;
    const loading1 = branchesData.loading;
    const error1 = branchesData.error;

    // if (loading1) return <PreloaderTwo />;

    if (error1 !== undefined) {
      alert("Server Error. " + error1.message);
      return null;
    }


    const getStudents = this.props.getStudents;
    const loading2 = getStudents.loading;
    const error2 = getStudents.error;


    // if (loading2) return <PreloaderTwo />;


    if (error2 != undefined) {
      alert("Server Error", +error2.message);
      return null;
    }

    return (

      <div className={Cookies.get("toggle")}>
        <div className="header-area">
          <NavbarOne onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <div id="sidebar" className={isBrowser == true ? "sidebar-menu d-none d-xl-block d-lg-block" : "sidebar-menu d-block d-xl-none d-lg-none"}>
            <SideNavbar onClick={() => this.menuToggler()} />
          </div>
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>
              {/* {

                loading1 ? (
                  <Container><Row className="my-3">
                    <Col>
                      <div class="spinner-border text-primary text-center loading-img-center"></div>
                    </Col>
                  </Row></Container>
                ) : (

                  <StundentDiaryHome
                    globals={globals.globals}
                    getStudents={getStudents.getNewEducationalStudents}
                  />
                )
              } */}

              <div className="content-wrapper mb-2">
                <Container fluid>
                  {loading1 || loading2 ? (
                    <PageCardShimmer filters={4} />
                  ) : (
                    <>
                      {
                        (() => {
                          // Branch list now comes from getBranches, restricted to the
                          // branches the user is authorized for. The branch_id cookie is a
                          // comma-separated list (e.g. "10,12,15"), so filter against every id.
                          let branchList = branchesData.getBranches || [];
                          if (Cookies.get("userlevel") != "1" && Cookies.get("userlevel") != "2") {
                            const authorizedIds = getAuthorizedBranchIds();
                            if (authorizedIds.length) {
                              branchList = branchList.filter((item) => authorizedIds.includes(String(item.id)));
                            }
                          }
                          // Preserve the prop shape StudentDiaryHome expects (globals.globalBranches).
                          const globalsData = { globalBranches: branchList };

                          return (
                            <>
                              <StundentDiaryHome
                                globals={globalsData}
                                getStudents={getStudents.getNewEducationalStudents}
                                diaryType={this.props.diaryType}
                              />
                            </>
                          );
                        })()
                      }
                    </>
                  )}
                </Container>
              </div>
            </Container>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default withRouter(
  compose(

    graphql(GET_BRANCHES,
      {
        options: props => ({
          variables: {
            institution_id: parseInt(Cookies.get("institutionid"))

          },
          // Default is cache-first; getBranches is a shared query already in the Apollo
          // cache from other pages, so cache-first serves it without a network call.
          // cache-and-network shows cached data immediately AND always refetches.
          fetchPolicy: "cache-and-network",
        }), name: "branchesData"
      }),
    graphql(GET_STUDENT_DETAILS, {
      options: (props) => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "getStudents",
    }),

  )
    (StudentDiary));
